import { tabCloser, tabTemplate, categoryCodeTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeRequestMarkdown } from '../actions';
import RequestMarkdownActions from '../components/RequestMarkdownActions';
import RequestMarkdownPanel from '../components/RequestMarkdownPanel';

export default {
  ...tabTemplate(
    'request-markdown',
    RequestMarkdownPanel,
    matchSingleUrl(['requests', 'markdown']),
    RequestMarkdownActions,
  ),
  ...tabCloser('closeRequestMarkdownTab', closeRequestMarkdown),
  access: ({ requests }, { isGuest }) => requests.read && !isGuest,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  dropDownIcon: 'file outline',
  icon: 'far fa-file',
  order: 520,
};
